import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "info-hero" }
const _hoisted_2 = { class: "hero-main" }
const _hoisted_3 = { class: "hero-avatar" }
const _hoisted_4 = { class: "hero-text" }
const _hoisted_5 = { class: "hero-title" }
const _hoisted_6 = { class: "hero-meta" }
const _hoisted_7 = { class: "meta-chip" }
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "meta-chip" }
const _hoisted_10 = { class: "meta-val" }
const _hoisted_11 = { class: "hero-actions" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "info-tabs-wrap" }
const _hoisted_15 = { class: "info-section" }
const _hoisted_16 = { class: "info-grid" }
const _hoisted_17 = { class: "info-card" }
const _hoisted_18 = { class: "info-icon" }
const _hoisted_19 = { class: "info-body" }
const _hoisted_20 = { class: "info-label" }
const _hoisted_21 = ["title"]
const _hoisted_22 = { class: "info-card" }
const _hoisted_23 = { class: "info-icon info-icon-cyan" }
const _hoisted_24 = { class: "info-body" }
const _hoisted_25 = { class: "info-label" }
const _hoisted_26 = { class: "info-value" }
const _hoisted_27 = { class: "info-card" }
const _hoisted_28 = { class: "info-icon info-icon-green" }
const _hoisted_29 = { class: "info-body" }
const _hoisted_30 = { class: "info-label" }
const _hoisted_31 = { class: "info-value" }
const _hoisted_32 = { class: "info-card" }
const _hoisted_33 = { class: "info-icon info-icon-purple" }
const _hoisted_34 = { class: "info-body" }
const _hoisted_35 = { class: "info-value" }
const _hoisted_36 = { class: "info-section" }
const _hoisted_37 = { class: "description-card" }
const _hoisted_38 = { class: "desc-header" }
const _hoisted_39 = { class: "desc-body" }
const _hoisted_40 = { class: "info-grid info-grid-2" }
const _hoisted_41 = { class: "info-card" }
const _hoisted_42 = { class: "info-icon info-icon-amber" }
const _hoisted_43 = { class: "info-body" }
const _hoisted_44 = { class: "info-value" }
const _hoisted_45 = { class: "info-card" }
const _hoisted_46 = { class: "info-icon info-icon-rose" }
const _hoisted_47 = { class: "info-body" }
const _hoisted_48 = { class: "info-value" }
const _hoisted_49 = {
  key: 0,
  class: "auth-warning"
}
const _hoisted_50 = { class: "device-card" }
const _hoisted_51 = { class: "device-title" }
const _hoisted_52 = { class: "device-chart" }

import { validateShipAuthorizationApi, getShipInfoApi } from "@/api/productApi";
import router from "@/router";
import { ShipVO } from "@/types/product";
import { ElMessage } from "element-plus";
import {
  ArrowLeft,
  Calendar,
  Clock,
  Document,
  OfficeBuilding,
  Promotion,
  Refresh,
  Setting,
  Ship,
  Warning,
} from "@element-plus/icons-vue";
import { computed, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import ShipTopoGraph from "@/components/product/ShipTopoGraph.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ShipInfoView',
  setup(__props) {

const route = useRoute();
const activeTab = ref<string>("info");

const shipId = computed(() => {
  return route.query.shipId as string;
});

watch(shipId, () => {
  getShipInfo();
});

const ship = ref<ShipVO>();

const getShipInfo = async () => {
  const response = await getShipInfoApi(shipId.value);
  if (response) {
    ship.value = response;
  } else {
    router.back();
  }
};

// 获取船舶写入授权情况
const shipWriteAuthorization = ref<boolean>(false);
const validateShipAuthorization = async () => {
  const readAuthority = await validateShipAuthorizationApi(shipId.value, 15);
  const writeAuthority = await validateShipAuthorizationApi(shipId.value, 16);
  if (!readAuthority && !writeAuthority) {
    router.replace({ name: "overall" });
  }
  if (writeAuthority) {
    shipWriteAuthorization.value = writeAuthority;
  }
};

// 创建升级计划按钮点击事件
const handleCreateUpgradePlanClick = () => {
  validateShipAuthorization();
  if (!shipWriteAuthorization.value) {
    ElMessage.error("用户对当前船舶的写入权限已过期，请重新申请");
  }
  router.push({
    name: "createUpgradePlan",
    query: {
      shipId: shipId.value,
    },
  });
};

// 运营管理协议点击事件
const handleOperationManageProtocolClick = () => {
  validateShipAuthorization();
  if (!shipWriteAuthorization.value) {
    ElMessage.error("用户对当前船舶的写入权限已过期，请重新申请");
  }
  router.push({
    name: "shipProtocolTemplate",
    query: {
      shipId: shipId.value,
      shipName: ship.value?.ship.name || "",
    },
  });
};

const formatTime = (t?: string | number) => {
  if (!t) return "—";
  const d = typeof t === "string" ? Date.parse(t) : t;
  if (isNaN(d)) return String(t);
  return new Date(d).toLocaleString("zh-CN", { hour12: false });
};

const shortId = (id?: string) => {
  if (!id) return "—";
  if (id.length <= 12) return id;
  return `${id.slice(0, 8)}…${id.slice(-4)}`;
};

/**
 * 在册时长（基于创建时间）
 */
const tenureLabel = computed(() => {
  const t = ship.value?.createtime;
  if (!t) return "—";
  const created = new Date(t).getTime();
  if (isNaN(created)) return "—";
  const diff = Date.now() - created;
  if (diff < 0) return "—";
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  if (days < 30) return `${days} 天`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months} 个月`;
  const years = Math.floor(months / 12);
  const restMonths = months % 12;
  return restMonths ? `${years} 年 ${restMonths} 个月` : `${years} 年`;
});

onMounted(() => {
  getShipInfo();
  validateShipAuthorization();
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (ship.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: ship.value.id,
        class: "ship-info-page"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"hero-bg\" data-v-6d7d07b6><svg viewBox=\"0 0 800 200\" preserveAspectRatio=\"none\" class=\"hero-svg\" data-v-6d7d07b6><circle cx=\"100\" cy=\"100\" r=\"180\" fill=\"rgba(255,255,255,0.05)\" data-v-6d7d07b6></circle><circle cx=\"650\" cy=\"40\" r=\"150\" fill=\"rgba(8,145,178,0.22)\" data-v-6d7d07b6></circle><path d=\"M 0 150 Q 200 100 400 130 T 800 110\" stroke=\"rgba(255,255,255,0.10)\" stroke-width=\"1\" fill=\"none\" data-v-6d7d07b6></path><path d=\"M 0 170 Q 220 140 420 160 T 800 140\" stroke=\"rgba(255,255,255,0.05)\" stroke-width=\"1\" fill=\"none\" data-v-6d7d07b6></path></svg><svg viewBox=\"0 0 64 64\" class=\"compass-deco\" aria-hidden=\"true\" data-v-6d7d07b6><circle cx=\"32\" cy=\"32\" r=\"28\" fill=\"none\" stroke=\"rgba(255,255,255,0.18)\" stroke-width=\"1.2\" data-v-6d7d07b6></circle><circle cx=\"32\" cy=\"32\" r=\"20\" fill=\"none\" stroke=\"rgba(255,255,255,0.10)\" stroke-width=\"1\" data-v-6d7d07b6></circle><circle cx=\"32\" cy=\"32\" r=\"3\" fill=\"rgba(255,255,255,0.8)\" data-v-6d7d07b6></circle><polygon points=\"32,10 34,32 32,32\" fill=\"rgba(255,255,255,0.85)\" data-v-6d7d07b6></polygon><polygon points=\"32,54 30,32 32,32\" fill=\"rgba(165,243,252,0.55)\" data-v-6d7d07b6></polygon></svg></div>", 1)),
          _createElementVNode("button", {
            class: "back-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowLeft))
              ]),
              _: 1
            }),
            _cache[2] || (_cache[2] = _createElementVNode("span", null, "返回", -1))
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(Ship))
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "hero-tag" }, "SHIP DETAIL · 船舶档案", -1)),
              _createElementVNode("h1", _hoisted_5, _toDisplayString(ship.value.ship.name), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "meta-key" }, "ID", -1)),
                  _createElementVNode("span", {
                    class: "meta-val",
                    title: ship.value.ship.id
                  }, _toDisplayString(shortId(ship.value.ship.id)), 9, _hoisted_8)
                ]),
                _createElementVNode("span", _hoisted_9, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "meta-key" }, "集团", -1)),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(ship.value.orgName || "—"), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                class: "action-btn action-primary",
                disabled: !shipWriteAuthorization.value,
                onClick: handleCreateUpgradePlanClick
              }, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Promotion))
                  ]),
                  _: 1
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("SI.createUpgradePlan")), 1)
              ], 8, _hoisted_12),
              _createElementVNode("button", {
                class: "action-btn action-secondary",
                disabled: !shipWriteAuthorization.value,
                onClick: handleOperationManageProtocolClick
              }, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Setting))
                  ]),
                  _: 1
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("SI.operationManageProtocol")), 1)
              ], 8, _hoisted_13)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_tabs, {
            modelValue: activeTab.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event)),
            class: "info-tabs"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: _ctx.$t('SI.info'),
                name: "info"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "section-title" }, [
                      _createElementVNode("span", { class: "title-bar" }),
                      _createElementVNode("span", null, "基础信息")
                    ], -1)),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Ship))
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("ship.id")), 1),
                          _createElementVNode("span", {
                            class: "info-value",
                            title: ship.value.ship.id
                          }, _toDisplayString(shortId(ship.value.ship.id)), 9, _hoisted_21)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Calendar))
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("ship.createtime")), 1),
                          _createElementVNode("span", _hoisted_26, _toDisplayString(formatTime(ship.value.ship.createtime)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Calendar))
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("ship.deliveryDate")), 1),
                          _createElementVNode("span", _hoisted_31, _toDisplayString(formatTime(ship.value.deliveryDate)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Refresh))
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "info-label" }, "更新时间", -1)),
                          _createElementVNode("span", _hoisted_35, _toDisplayString(formatTime(ship.value.ship.updatetime)), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "section-title" }, [
                      _createElementVNode("span", { class: "title-bar" }),
                      _createElementVNode("span", null, "船舶资料")
                    ], -1)),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Document))
                          ]),
                          _: 1
                        }),
                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "desc-label" }, "描述", -1))
                      ]),
                      _createElementVNode("div", _hoisted_39, _toDisplayString(ship.value.ship.description || "暂无描述"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(OfficeBuilding))
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "info-label" }, "所属集团", -1)),
                          _createElementVNode("span", _hoisted_44, _toDisplayString(ship.value.orgName || "—"), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Clock))
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _cache[11] || (_cache[11] = _createElementVNode("span", { class: "info-label" }, "在册时长", -1)),
                          _createElementVNode("span", _hoisted_48, _toDisplayString(tenureLabel.value), 1)
                        ])
                      ])
                    ])
                  ]),
                  (!shipWriteAuthorization.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Warning))
                          ]),
                          _: 1
                        }),
                        _cache[13] || (_cache[13] = _createElementVNode("span", null, "当前账户对该船舶无写入权限，操作按钮已禁用。可前往集团详情重新申请授权。", -1))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_tab_pane, {
                label: _ctx.$t('SI.deviceInfo'),
                name: "device",
                lazy: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("h3", _hoisted_51, _toDisplayString(_ctx.$t("SI.customDeviceTopoGraph")), 1),
                    _createElementVNode("div", _hoisted_52, [
                      _createVNode(ShipTopoGraph, { "ship-id": shipId.value }, null, 8, ["ship-id"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_tab_pane, {
                label: _ctx.$t('SI.map'),
                name: "map",
                disabled: true
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})